import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6 ml-4 overflow-y-auto" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "pr-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Title, {
        label: _ctx.$t('Detail Bagging')
      }, null, 8, ["label"]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.tableTitle.totalSttKoli'),
          value: `${_ctx.formatQuantity(_ctx.detailData.totalStt)} (${_ctx.formatQuantity(_ctx.detailData.totalPiece)} koli)`
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.tableTitle.totalSTTDG'),
          value: `${_ctx.formatQuantity(_ctx.detailData.totalSttDgCount)} STT`
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: "Chargeable weight (STT)",
          value: _ctx.formatWeight(_ctx.detailData.totalSttChargeableWeight)
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.chargeableWeightReweigh'),
          value: _ctx.formatWeight(_ctx.detailData.totalBagChargeableWeight)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.totalSttGrossWeight'),
          value: _ctx.formatWeight(_ctx.detailData.totalSttGrossWeight)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.totalBeratKotorBag'),
          value: _ctx.formatWeight(_ctx.detailData.totalBagGrossWeight)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.totalSttVolumeWeight'),
          value: _ctx.formatWeight(_ctx.totalVolumeWeight)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.totalBeratVolumeBag'),
          value: _ctx.formatWeight(_ctx.detailData.totalBagVolumeWeight)
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: _ctx.$t('bagging.buktiFotoPerubahan')
        }, {
          default: _withCtx(() => [
            (_ctx.detailData.photoProof?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.photoProof, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-1 rounded-lg bg-gray-lp-1000 w-10 h-10 flex items-center justify-center"
                    }, [
                      _createVNode("img", {
                        src: item,
                        class: "w-full h-full object-cover rounded-lg",
                        alt: `Bukti foto perubahan berat koli ${index + 1}`,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPreviewPhotoProof = true))
                      }, null, 8, ["src", "alt"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_4, "-"))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_TableV2, {
          data: _ctx.detailData.sttResult,
          columns: _ctx.columns,
          borderTop: false,
          hidePagination: true,
          isRightFreeze: true,
          isPinnedScrollBottom: false,
          totalColumnFreeze: 0
        }, null, 8, ["data", "columns"])
      ])
    ]),
    (_ctx.isPreviewPhotoProof)
      ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
          key: 0,
          data: _ctx.detailData.photoProof,
          onClose: () => (_ctx.isPreviewPhotoProof = false)
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}